// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleParticipants_root__MigGW","title":"ArticleParticipants_title__6MZ7Z","list":"ArticleParticipants_list__bYRqu"};